<template>
  <div class="fill-height pa-2">
    <v-card class="fill-height d-flex flex-column" style="max-height: 100%; position: relative; " >
      <v-progress-linear v-if="showLoading" absolute indeterminate></v-progress-linear>
      <v-card-title class="pa-0 ma-0 d-flex align-center">
        <div class="dlg-title-bar flex-grow-1">
          {{ selectedEmployee.name }}
        </div>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn
              color="indigo"
              class="mx-1"
              icon
              v-on="on"
              @click="showAddDevices = true"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          Add Devices
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn
              color="blue"
              class="mx-1"
              icon
              v-on="on"
              @click="showTransferTeam = true"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          Assign Team
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn
              icon
              color="green"
              class="mx-1"
              v-on="on"
              @click="showRenameEmployee = true"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          Rename Employee
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn
              icon
              color="error"
              class="mx-1"
              v-on="on"
              @click="showDisableEmployee = true"
            >
              <v-icon>{{ selectedEmployee.disabled ? 'mdi-lock-off' : 'mdi-lock' }}</v-icon>
            </v-btn>
          </template>
          {{ selectedEmployee.disabled ? 'Enable Employee' : 'Disable Employee' }}
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn
              icon
              color="red"
              class="mx-1 mr-3"
              v-on="on"
              @click="showConfirmDelete = true"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          Delete Employee
        </v-tooltip>

      </v-card-title>

      <app-divider label="Employee Options" show-expanded :expanded.sync="showEmployeeOptions"/>

      <v-scroll-y-transition hide-on-leave>
        <div v-if="showEmployeeOptions" class="pb-2">
          <div class="d-flex align-center px-3 py-2" style="height: 56px">
            <div v-if="!team" class="flex-grow-1 d-flex align-center justify-center">
              <v-icon :color="!team ? 'error' : null" left>mdi-account-group</v-icon>
              <div class="px-3">
                <div v-if="!team" class="text-overline error--text text-center" >
                  No Team Assigned
                </div>
                <div v-else>
                  <div class="body-1">{{team.name}}</div>
                </div>
              </div>
            </div>
            <div v-else class="flex-grow-1 px-3" style="cursor: pointer">
              <v-text-field
                dense
                outlined
                color="primary"
                :value="team.name"
                label="Team"
                prepend-inner-icon="mdi-account-group"
                readonly
                hide-details
                class="pa-0 ma-0"
                @click="team ? gotoTeam(team._id) : showAssignTeam = true"
                style="cursor: pointer"
              ></v-text-field>
            </div>


            <div>
              <v-btn
                outlined
                small
                color="blue"
                class="my-1"
                @click="showAssignTeam = true"
              >
                <v-icon left>mdi-swap-horizontal</v-icon>
                Assign Team
              </v-btn>
            </div>
          </div>

<!--          <div class="d-flex align-center pl-6 pr-4 py-2" style="height: 56px">-->
<!--            <v-text-field-->
<!--              dense-->
<!--              outlined-->
<!--              color="primary"-->
<!--              label="Company Employee Number"-->
<!--              prepend-inner-icon="mdi-badge-account"-->
<!--              hide-details-->
<!--              class="pa-0 ma-0"-->
<!--              style="cursor: pointer"-->
<!--              :value="selectedEmployee.employeeNumber"-->
<!--            ></v-text-field>-->
<!--          </div>-->

          <div
            class="d-flex px-3 pt-2 mb-2"
            style="height: 56px"
          >
            <v-form
              ref="employeeNumber"
              class="flex-grow-1 px-3"
              style="cursor: pointer"
              @submit.stop.prevent
            >
              <v-text-field
                dense
                outlined
                color="primary"
                class="pa-0 ma-0"
                style="cursor: pointer"
                label="Company Employee Number"
                prepend-inner-icon="mdi-badge-account"
                v-model="selectedEmployeeRef.employeeNumber"
                :rules="[duplicateEmployeeNumber]"
              ></v-text-field>
            </v-form>


            <div style="height: 100%">
              <v-btn
                small
                outlined
                color="blue"
                class="my-1"
                :loading="showLoading"
                @click="updateEmployee"
              >
                <v-icon left>mdi-content-save</v-icon>
                Update Employee
              </v-btn>
            </div>
          </div>

          <div class="px-3 d-flex align-center justify-space-between">
            <div class="px-3 d-flex align-center flex-grow-1">
              <v-icon :color="selectedEmployee.trackActivity ? null : 'error'">
                {{selectedEmployee.trackActivity ? 'mdi-timer' : 'mdi-timer-off'}}
              </v-icon>
              <div class="body-1 px-3 py-2" :class="selectedEmployee.trackActivity ? null : 'error--text'">
                Activity Tracking {{selectedEmployee.trackActivity ? 'Enabled' : 'Disabled'}}
              </div>
            </div>
            <v-btn
              outlined
              small
              :color="selectedEmployee.trackActivity ? 'error' : 'green'"
              :loading="disablingTracking"
              :disabled="disablingTracking"
              @click="disableTracking"
            >
              <v-icon left>
                {{!selectedEmployee.trackActivity ? 'mdi-timer' : 'mdi-timer-off'}}
              </v-icon>
              {{!selectedEmployee.trackActivity ? 'Enable' : 'Disable'}}
            </v-btn>
          </div>

          <div class="px-3 d-flex align-center justify-space-between">
            <div class="px-3 d-flex align-center flex-grow-1">
              <v-icon :color="selectedEmployee.enableScreenshots ? null : 'error'">
                {{selectedEmployee.enableScreenshots ? 'mdi-camera' : 'mdi-camera-off'}}
              </v-icon>
              <div class="body-1 px-3 py-2" :class="selectedEmployee.enableScreenshots ? null : 'error--text'">
                Screenshots {{selectedEmployee.enableScreenshots ? 'Enabled' : 'Disabled'}}
              </div>
            </div>
            <v-btn
              outlined
              small
              :color="selectedEmployee.enableScreenshots ? 'error' : 'green'"
              :loading="disablingScreenshots"
              :disabled="disablingScreenshots"
              @click="disableScreenshots"
            >
              <v-icon left>
                {{!selectedEmployee.enableScreenshots ? 'mdi-camera' : 'mdi-camera-off'}}
              </v-icon>
              {{!selectedEmployee.enableScreenshots ? 'Enable' : 'Disable'}}
            </v-btn>
          </div>

          <div class="px-3 d-flex align-center justify-space-between">
            <div class="px-3 d-flex align-center flex-grow-1">
              <v-icon :color="!selectedEmployee.disablePersonalisedStats ? null : 'error'">
                {{!selectedEmployee.disablePersonalisedStats ? 'mdi-chart-line' : 'mdi-close'}}
              </v-icon>
              <div class="body-1 px-3 py-2" :class="!selectedEmployee.disablePersonalisedStats ? null : 'error--text'">
                Personalized Stats {{!selectedEmployee.disablePersonalisedStats ? 'Enabled' : 'Disabled'}}
              </div>
            </div>
            <v-btn
              outlined
              small
              :color="!selectedEmployee.disablePersonalisedStats ? 'error' : 'green'"
              :loading="disablingStats"
              :disabled="disablingStats"
              @click="disablePersonalizedStats"
            >
              <v-icon left>
                {{selectedEmployee.disablePersonalisedStats ? 'mdi-chart-line' : 'mdi-close'}}
              </v-icon>
              {{selectedEmployee.disablePersonalisedStats ? 'Enable' : 'Disable'}}
            </v-btn>
          </div>
        </div>
      </v-scroll-y-transition>


      <app-divider
        label="Devices"
        :show-search="showDevices"
        :search.sync="devicesFilterStr"
      >
        <template v-slot:action>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn
                dark
                color="primary"
                icon
                v-on="on"
                @click="showAddDevices = true"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            Add Devices
          </v-tooltip>
        </template>
      </app-divider>
      <v-scroll-y-transition hide-on-leave>
        <v-list
          v-if="showDevices"
          dense
          class="mt-0 pt-0 flex-grow-1 of-y"
          style="padding-bottom: 32px;"
        >
          <v-list-item
            v-for="device in devicesByEmployeeSorted"
            :key="device._id"
            @click.self="gotoDeviceSettings(device._id)"
          >
            <v-list-item-avatar @click="gotoDeviceSettings(device._id)">
              <img src="@/assets/teams.svg" style="height: 24px !important;" v-if="devicesRef[device._id].o365TenantUser">
              <v-icon v-else>{{!devicesRef[device._id].phone ? 'mdi-cellphone-link' : 'mdi-phone'}}</v-icon>
            </v-list-item-avatar>

            <v-list-item-content @click="gotoDeviceSettings(device._id)">
              <v-list-item-title v-text="device.name"/>
              <v-list-item-subtitle v-text="device.hardwareDescription"/>
            </v-list-item-content>


            <v-list-item-action>
              <div class="d-flex align-center mr-2">
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      color="blue"
                      :loading="loadingDevices.includes(device._id)"
                      :disabled="loadingDevices.includes(device._id)"
                      v-on="on"
                      @click="transferDeviceStart(device)"
                      class="mr-2"
                    >
                      <v-icon>mdi-swap-horizontal</v-icon>
                    </v-btn>
                  </template>
                  Transfer Device
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      color="error"
                      v-on="on"
                      @click="mergeDeviceInit(device)"
                    >
                      <v-icon>mdi-source-merge</v-icon>
                    </v-btn>
                  </template>
                  Merge into another device & delete
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      color="error"
                      :loading="loadingDevices.includes(device._id)"
                      :disabled="loadingDevices.includes(device._id)"
                      v-on="on"
                      @click="removeDevice(device)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  Remove Device
                </v-tooltip>

                <v-tooltip
                  top
                  v-if="onlineDeviceIds.includes(device._id)"
                >
                  <template v-slot:activator="{on}">
                    <v-icon color="green" v-on="on" class="pl-2">mdi-lan-connect</v-icon>
                  </template>
                  Device Online
                </v-tooltip>
                <!--                                TODO Add After Cert-->
                <!--                                <v-tooltip-->
                <!--                                        top-->
                <!--                                        v-else-->
                <!--                                >-->
                <!--                                    <template v-slot:activator="{on}">-->
                <!--                                        <v-icon color="error" v-on="on" class="pl-2">mdi-lan-disconnect</v-icon>-->
                <!--                                    </template>-->
                <!--                                    Device Offline-->
                <!--                                    &lt;!&ndash;                                    {{!!realTimeByDeviceId[device._id] ? ` - Last Active: ${format(new Date(realTimeByDeviceId[device._id].lastActive), dateFormats.longDate)}` : null}}&ndash;&gt;-->
                <!--                                </v-tooltip>-->
              </div>

            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-scroll-y-transition>
    </v-card>

    <!--Disable-->
    <app-dlg
      v-if="showDisableEmployee"
      :show-dlg.sync="showDisableEmployee"
      :title="selectedEmployee.disabled ? 'Enable Employee' : 'Disable Employee'"
    >

      <template>
        Please confirm that you would like to {{selectedEmployee.disabled ? 'enable' : 'disable'}} the employee {{selectedEmployee.name}}
      </template>

      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showDisableEmployee = false"
          outlined
          size="small"
          :disabled="disablingEmployee"
        >Cancel</v-btn>

        <v-btn
          @click="disableEmployee"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="disablingEmployee"
          :loading="disablingEmployee"
        >Confirm</v-btn>
      </template>
    </app-dlg>
    <!--Rename-->
    <app-dlg
      v-if="showRenameEmployee"
      :show-dlg.sync="showRenameEmployee"
      :model-string.sync="renameEmployeeValue"
      title="Rename Employee"
      show-tf
      placeholder="eg. Jerry Smith"
      label="Employee Name"
      class="pa-0 ma-0 mx-2"
      color="primary"
      outlined
      dense
      :rules="[validationRules.required, duplicateEmployeeName]"
      :disabled="renamingEmployee"
      @enter="renameEmployee()"
    >
      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showRenameEmployee = false"
          outlined
          size="small"
          :disabled="renamingEmployee"
        >Cancel</v-btn>

        <v-btn
          @click="renameEmployee"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="!renameEmployeeValue || renamingEmployee || duplicateEmployeeName(renameEmployeeValue) !== true"
          :loading="renamingEmployee"
        >Rename</v-btn>
      </template>
    </app-dlg>
    <!--Assign Team-->
    <app-dlg
      v-if="showAssignTeam"
      :show-dlg.sync="showAssignTeam"
      title="Assign Employee To Team"
    >

      <template>
        <v-autocomplete
          dense
          outlined
          color="primary"
          v-model="assignTeamSelectedTeam"
          label="Team"
          placeholder="eg. Finance"
          :items="availableTeams"
          item-text="name"
          item-value="_id"
          prepend-inner-icon="mdi-account-group"
          ref="assignTeamSelect"
        ></v-autocomplete>
      </template>

      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showAssignTeam = false"
          outlined
          size="small"
          :disabled="assigningTeam"
        >
          Cancel
        </v-btn>

        <v-btn
          @click="assignTeam"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="assigningTeam || !assignTeamSelectedTeam"
          :loading="assigningTeam"
        >Assign</v-btn>
      </template>
    </app-dlg>
    <!--Transfer Device-->
    <app-dlg
      ref="transferDeviceDlg"
      v-if="showTransferDevice"
      :show-dlg.sync="showTransferDevice"
      title="Transfer Device"
      :default-padding="false"
    >

      <app-list
        v-model="transferToEmployee"
        :items="employees.filter(employee => !employee.disabled && employee !== selectedEmployee).sort(nameSort)"
        :multiple="false"
        headline-key="name"
        item-key="_id"
        :show-check-boxes="true"
        :return-object="false"
        class="fill-height of-y"
        :height="400"
      />

      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showTransferDevice = false"
          outlined
          size="small"
        >Cancel</v-btn>

        <v-btn
          @click="transferDevice"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="!transferToEmployee"
        >Transfer</v-btn>
      </template>
    </app-dlg>
    <!--Add Devices-->
    <app-dlg
      ref="transferEmpDlg"
      v-if="showAddDevices"
      :show-dlg.sync="showAddDevices"
      title="Add Devices"
      :default-padding="false"
    >

      <app-list
        v-model="addDevices"
        :items="devices.filter(device => !device.disabled && !device.employeeId).sort(nameSort)"
        :multiple="true"
        headline-key="name"
        sub-line-key="hardwareDescription"
        item-key="_id"
        :show-check-boxes="true"
        :return-object="false"
        class="fill-height of-y"
        :height="400"
      />

      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showAddDevices = false"
          outlined
          size="small"
          :disabled="addingDevices"
        >
          Cancel
        </v-btn>

        <v-btn
          @click="addDevicesToEmployee"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="addingDevices || !addDevices || addDevices.length === 0"
          :loading="addingDevices"
        >
          {{ addDevices.length === 1 ? 'Add Device' : 'Add Devices' }}
        </v-btn>
      </template>
    </app-dlg>
    <!--Delete-->
    <v-dialog
      v-if="showConfirmDelete"
      :value="showConfirmDelete"
      :persistent="true"
      width="400"
    >
      <v-card>
        <v-progress-linear
          v-if="deletingEmployee"
          color="primary"
          indeterminate
          absolute
        ></v-progress-linear>

        <v-card-title class="dlg-title-bar">
          Delete Employee
        </v-card-title>

        <v-card-text v-if="!devicesByEmployeeSorted.length">
          Please confirm the removal of the employee: {{selectedEmployee.name}}
          <br>
          Please note that this action cannot be undone
        </v-card-text>

        <v-card-text v-else class="overline error--text pb-4 text-center">
          Error: Employee Not Empty
          <br>
          Please transfer all devices from "{{selectedEmployee.name}}" before proceeding
        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            class="ml-2"
            small
            color="primary"
            @click="showConfirmDelete = false"
            outlined
            size="small"
            :disabled="deletingEmployee"
          >
            Cancel
          </v-btn>

          <v-btn
            @click="deleteEmployee"
            small
            class="ml-2"
            color="secondary"
            variant="contained"
            size="small"
            :disabled="deletingEmployee || !!devicesByEmployeeSorted.length"
            :loading="deletingEmployee"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Merge Device-->
    <app-dlg
      ref="mergeDeviceDlg"
      v-if="showMergeDevice"
      :show-dlg.sync="showMergeDevice"
      title="Merge Device"
      :default-padding="false"
    >

      <template>

        <div>
          <div class="overline error--text d-flex justify-center text-sm-center"  style="line-height: 1.5">
            <v-icon class="pr-4" color="error">mdi-alert</v-icon>
            Warning! <br> This action can not be undone.
            <v-icon class="pl-4" color="error">mdi-alert</v-icon>
          </div>

          <div class="pa-2">
            <div class="caption">
              Source Device:
            </div>
            <div class="body-2 d-flex align-center pt-2">
              <v-tooltip
                top
                v-if="onlineDeviceIds.includes(mergeDeviceSource._id)"
              >
                <template v-slot:activator="{on}">
                  <v-icon color="green" v-on="on" class="px-2">mdi-lan-connect</v-icon>
                </template>
                Device Online
              </v-tooltip>
              <!--                            TODO Add After Cert-->
              <!--                            <v-tooltip-->
              <!--                                    top-->
              <!--                                    v-else-->
              <!--                            >-->
              <!--                                <template v-slot:activator="{on}">-->
              <!--                                    <v-icon color="error" v-on="on" class="px-2">mdi-lan-disconnect</v-icon>-->
              <!--                                </template>-->
              <!--                                Device Offline-->
              <!--                                &lt;!&ndash;                                    {{!!realTimeByDeviceId[device._id] ? ` - Last Active: ${format(new Date(realTimeByDeviceId[device._id].lastActive), dateFormats.longDate)}` : null}}&ndash;&gt;-->
              <!--                            </v-tooltip>-->
              <div class="flex-grow-1">
                <div style="line-height: 1">
                  {{mergeDeviceSource.name}}
                </div>
                <div class="text-truncate text-caption greyType--text">
                  {{mergeDeviceSource.hardwareDescription}}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="caption px-2 pt-2">
          Destination Device:
        </div>
        <app-list
          v-model="mergeDeviceDest"
          :items="devicesByEmployeeSorted.filter(device => device._id !== mergeDeviceSource._id && device.phone === mergeDeviceSource.phone && device.o365TenantUser === mergeDeviceSource.o365TenantUser)"
          :multiple="false"
          headline-key="name"
          sub-line-key="hardwareDescription"
          item-key="_id"
          :show-check-boxes="true"
          :return-object="true"
          class="fill-height of-y"
          :height="400"
          :use-headline-slot="true"
        >
          <template #headline="{value}">

            <div class="d-flex align-center py-1">
              <!--                            TODO Add After Cert-->
              <!--                            <div>-->
              <!--                                <v-tooltip-->
              <!--                                        top-->
              <!--                                        v-if="onlineDeviceIds.includes(value._id)"-->
              <!--                                >-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-icon color="green" v-on="on" class="pr-2">mdi-lan-connect</v-icon>-->
              <!--                                    </template>-->
              <!--                                    Device Online-->
              <!--                                </v-tooltip>-->
              <!--                                <v-tooltip-->
              <!--                                        top-->
              <!--                                        v-else-->
              <!--                                >-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-icon color="error" v-on="on" class="pr-2">mdi-lan-disconnect</v-icon>-->
              <!--                                    </template>-->
              <!--                                    Device Offline-->
              <!--                                    &lt;!&ndash;                                    {{!!realTimeByDeviceId[device._id] ? ` - Last Active: ${format(new Date(realTimeByDeviceId[device._id].lastActive), dateFormats.longDate)}` : null}}&ndash;&gt;-->
              <!--                                </v-tooltip>-->
              <!--                            </div>-->
              <div class="flex-grow-1">
                <div style="line-height: 1">
                  {{value.name}}
                </div>
                <div class="text-truncate text-caption greyType--text">
                  {{value.hardwareDescription}}
                </div>
              </div>
            </div>


          </template>
        </app-list>
      </template>



      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="showMergeDevice = false"
          outlined
          size="small"
          :disabled="mergingDevice"
        >
          Cancel
        </v-btn>

        <v-btn
          @click="mergeDevices"
          small
          class="ml-2"
          color="primary"
          variant="contained"
          size="small"
          :disabled="mergingDevice || !mergeDeviceDest"
          :loading="mergingDevice"
        >
          Merge & Delete
        </v-btn>
      </template>
    </app-dlg>


  </div>
</template>

<script>
import {Employee} from "@/models/employee";
import AppList from "@/components/Shared/AppList/AppList";
import AppDlg from "@/components/Shared/AppDlg";
import {arrSplice, nameSort, validationRules} from "@/core/codeFunctions";
import {mapActions, mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import {Device} from "@/models/device";

export default {
  components: {AppDivider, AppDlg, AppList},
  props: {
    selectedEmployee: Employee
  },
  data() {
    return {
      showLoading: false,
      fab: false,
      validationRules: validationRules,
      showEmployeeOptions: true,
      nameSort: nameSort,

      showDisableEmployee: false,
      disablingEmployee: false,
      showRenameEmployee: false,
      renameEmployeeValue: null,
      renamingEmployee: false,

      showAssignTeam: false,
      assignTeamSelectedTeam: null,
      assigningTeam: false,

      showTransferTeam: false,
      transferOwnershipSelectedEmployee: null,
      transferringOwnership: false,

      disablingTracking: false,
      disablingScreenshots: false,

      showDevices: true,
      devicesFilterStr: null,

      loadingDevices: [],
      showTransferDevice: false,
      transferToEmployee: null,

      addDevices: null,
      showAddDevices: false,
      addingDevices: false,

      showConfirmDelete: false,
      deletingEmployee: false,

      showMergeDevice: false,
      mergeDeviceSource: null,
      mergeDeviceDest: null,
      mergingDevice: false,
      disablingStats: false,

      selectedEmployeeRef: null
    }
  },
  watch: {
    'selectedEmployee': {
      immediate: true,
      deep: true,
      handler(val) {
        this.disablingEmployee = false;
        this.selectedEmployeeRef = new Employee(JSON.parse(JSON.stringify(val)));
      }
    },

    showAddDevices(val) {
      this.addDevices = [];
      this.addingDevices = false;
    },

    // selectedEmployee() {
    //   this.disablingEmployee = false;
    // },

    showAssignTeam(val) {
      this.assignTeamSelectedTeam = this.selectedEmployee.teamId || null;
      this.assigningTeam = false;
      if (val)
        setTimeout(() => {
          this.$refs.assignTeamSelect.focus()
        }, 500)
    },

    showTransferTeam() {
      this.transferOwnershipSelectedEmployee = null;
      this.transferringOwnership = false;
    },
    showRenameEmployee(val) {
      if (val) {
        this.renamingEmployee = false;
        this.renameEmployeeValue = this.selectedEmployee.name;
      }
    }
  },
  methods: {
    ...mapActions(['gotoTeam', 'gotoDeviceSettings']),

    async mergeDevices() {
      try {
        this.mergingDevice = true
        const result = await this.$newReq('POST', `devices/mergeDevices`, {source: this.mergeDeviceSource._id, dest: this.mergeDeviceDest._id})
        this.mergeDeviceSource = null;
        this.mergeDeviceDest = null
        this.showMergeDevice = false;
      } catch (e) {
        this.$snack.netWorkError();
      } finally {
        this.mergingDevice = false
      }
    },

    mergeDeviceInit(device) {
      this.mergeDeviceDest = null;
      this.showMergeDevice = true;
      this.mergeDeviceSource = device
    },

    async deleteEmployee() {
      this.deletingEmployee = true
      try {
        this.deletingEmployee = true
        const res = await this.selectedEmployee.delete()
        this.showConfirmDelete = false
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.deletingEmployee = false;
      }
    },

    async addDevicesToEmployee() {
      try {
        this.addingDevices = true
        const res = await this.$newReq('POST', `employees/addDevices`, {
          employeeId: this.selectedEmployee._id,
          deviceIds: this.addDevices
        })
        this.showAddDevices = false;
      } catch (e) {
        this.$snack.netWorkError();
        this.addingDevices = false;
      }
    },

    async transferDevice() {
      const device = this.$refs.transferDeviceDlg.refVal
      this.showTransferDevice = false;

      this.loadingDevices.push(device._id)
      try {
        const tDevice = new Device(JSON.parse(JSON.stringify(device)))
        device.once('update', () => {
          arrSplice(this.loadingDevices, (deviceId) => device._id === deviceId)
        })
        tDevice.employeeId = this.transferToEmployee;
        await tDevice.update('employeeId')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      }
    },

    transferDeviceStart(device) {
      this.showTransferDevice = true;
      this.$nextTick(() => {
        this.$refs.transferDeviceDlg.refVal = device
      })
    },


    async removeDevice(device) {
      this.loadingDevices.push(device._id)
      try {
        const tDevice = new Device(JSON.parse(JSON.stringify(device)))
        device.once('update', () => {
          arrSplice(this.loadingDevices, (deviceId) => device._id === deviceId)
        })
        tDevice.employeeId = null;
        await tDevice.update('employeeId')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.renamingTeam = false
      }
    },
    async disableTracking() {
      try {
        this.disablingTracking = true;
        const employee = new Employee({...this.selectedEmployee, trackActivity: !this.selectedEmployee.trackActivity})
        this.selectedEmployee.once('update', () => {
          this.disablingTracking = false
        })
        await employee.update('trackActivity')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.disablingTracking = false
      }
    },

    async disableScreenshots() {
      try {
        this.disablingScreenshots = true;
        const employee = new Employee({...this.selectedEmployee, enableScreenshots: !this.selectedEmployee.enableScreenshots})
        this.selectedEmployee.once('update', () => {
          this.disablingScreenshots = false
        })
        await employee.update('enableScreenshots')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.disablingScreenshots = false
      }
    },

    async disablePersonalizedStats() {
      try {
        this.disablingStats = true;
        const employee = new Employee({...this.selectedEmployee, disablePersonalisedStats: !this.selectedEmployee.disablePersonalisedStats})
        this.selectedEmployee.once('update', () => {
          this.disablingStats = false
        })
        await employee.update('disablePersonalisedStats')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.disablingStats = false
      }
    },

    async assignTeam() {
      try {
        this.assigningTeam = true;
        const employee = new Employee({...this.selectedEmployee, teamId: this.assignTeamSelectedTeam})
        this.selectedEmployee.once('update', () => {
          this.assigningTeam = false
          this.showAssignTeam = false;
        })
        await employee.update('teamId')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.assigningTeam = false
      }
    },
    // async transferOwnership() {
    //     try {
    //         this.transferringOwnership = true;
    //         const employee = new Employee({...this.selectedEmployee, employeeId: this.transferOwnershipSelectedEmployee})
    //         this.selectedEmployee.once('update', () => {
    //             this.transferringOwnership = false
    //             this.showTransferTeam = false;
    //             this.$emit('checkSelected')
    //         })
    //         await employee.update('employeeId')
    //     } catch (e) {
    //         console.log(e)
    //         this.$snack.netWorkError()
    //         this.transferringOwnership = false
    //     }
    // },
    async renameEmployee() {
      try {
        if (!this.renameEmployeeValue)
          return
        this.renamingEmployee = true;
        const employee = new Employee({...this.selectedEmployee, name: this.renameEmployeeValue})
        this.selectedEmployee.once('update', () => {
          this.renamingEmployee = false
          this.showRenameEmployee = false;
          this.$emit('checkSelected')
        })
        await employee.update('name')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.renamingEmployee = false
      }
    },
    duplicateEmployeeName(val) {
      if (!val)
        return 'Required value'
      const employeeNames = this.employees.map(emp => (emp.name || '').toLowerCase())
      if (employeeNames.includes((val || '').toLowerCase()))
        return 'Employee name has already been used'
      return true
    },


    async disableEmployee() {
      try {
        this.disablingEmployee = true;
        const employee = new Employee({...this.selectedEmployee, disabled: !this.selectedEmployee.disabled})
        this.selectedEmployee.once('update', () => {
          this.disablingEmployee = false
          this.showDisableEmployee = false;
          this.$emit('checkSelected')
        })
        await employee.update('disabled')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
        this.disablingEmployee = false
      }
    },
    async updateEmployee() {

      if (!this.$refs.employeeNumber.validate())
        return '';

      // if (typeof this.duplicateEmployeeNumber(this.selectedEmployeeRef.employeeNumber) === 'string')
      //   return;

      try {
        const updateKeys = ['employeeNumber'];
        this.showLoading = true;
        this.selectedEmployee.once('update', (payload) => {
          this.showLoading = false;
        })

        await this.selectedEmployeeRef.update(...updateKeys)
      } catch (e) {
        console.log(e);
      } finally {
        this.showLoading = false;
      }
    },
    duplicateEmployeeNumber(val) {
      if (val === this.selectedEmployee.employeeNumber)
        return true;

      if (!val)
        return true
      const employeeNUmber = this.employees.map(emp => (emp.employeeNumber || '').toLowerCase());
      if (employeeNUmber.includes((val || '').toLowerCase()))
        return 'Employee number has already been used';
      return true;
    },
  },
  computed: {
    ...mapGetters(['employees', 'teamsRef', 'teamsWithAccess', 'devicesByEmployee', 'devices', 'devicesRef', 'onlineDeviceIds']),
    team() {
      return this.selectedEmployee.teamId && this.teamsRef[this.selectedEmployee.teamId] ? this.teamsRef[this.selectedEmployee.teamId] : null
    },
    availableEmployees() {
      return this.employees.filter((emp) => !emp.disabled).sort(nameSort)
    },
    availableTeams() {
      return [...this.teamsWithAccess].sort(nameSort)
    },
    devicesByEmployeeSorted() {
      if (!this.devicesByEmployee[this.selectedEmployee._id])
        return []
      return [...this.devicesByEmployee[this.selectedEmployee._id]].sort(nameSort)
    },
  }

}
</script>

<style scoped>

</style>